module.exports = __webpack_public_path__ + "static/media/floor.4c9135b0.jpeg";